import { COUNTRY_CONFIG, COUNTRY_OPTIONS, DEFAULT_COUNTRY_CODE, type CountryCode } from 'shared/config/countries';

import { Input } from '@/components/ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

export const parsePhoneDigits = (
  digits: string,
  defaultCountry: CountryCode = DEFAULT_COUNTRY_CODE
): { country: CountryCode; local: string } => {
  const clean = digits.replace(/\D/g, '');
  for (const option of COUNTRY_OPTIONS) {
    if (clean.startsWith(option.prefix)) {
      return { country: option.code, local: clean.slice(option.prefix.length) };
    }
  }
  return { country: defaultCountry, local: clean };
};

// Keep in sync with canSendWhatsAppMessage in apps/lidz_back/src/utils/modelHelpers/phoneHelpers.ts
export const isValidPhoneForCountry = (digits: string, country: CountryCode): boolean =>
  COUNTRY_CONFIG[country].phonePattern.test(digits);

interface Props {
  value: string;
  onChange: (digits: string) => void;
  inputId?: string;
  className?: string;
  disabled?: boolean;
  defaultCountry?: CountryCode;
}

const PhoneInput = ({ value, onChange, inputId, className, disabled, defaultCountry }: Props) => {
  const { country, local } = parsePhoneDigits(value, defaultCountry);
  const selected = COUNTRY_CONFIG[country];

  const handleCountryChange = (next: CountryCode) => {
    onChange(`${COUNTRY_CONFIG[next].prefix}${local}`);
  };

  const handleLocalChange = (nextLocal: string) => {
    const cleanLocal = nextLocal.replace(/\D/g, '');
    onChange(`${selected.prefix}${cleanLocal}`);
  };

  return (
    <div className={`flex gap-2 ${className ?? ''}`}>
      <Select value={country} onValueChange={(v) => handleCountryChange(v as CountryCode)} disabled={disabled}>
        <SelectTrigger className="w-24">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {COUNTRY_OPTIONS.map((option) => (
            <SelectItem key={option.code} value={option.code}>
              {option.flag} +{option.prefix}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <Input
        id={inputId}
        className="flex-1"
        value={local}
        onChange={(e) => handleLocalChange(e.target.value)}
        type="tel"
        disabled={disabled}
      />
    </div>
  );
};

export default PhoneInput;
